import React from "react";
import Button from "../../../components/Button/Button";

import "./CTAButton.css";
const CTAButton = () => (
    <div className="cta-btn-container">
        <Button
            btnText="Get the App"
            pagePath="/app-download/"
            btnStyle="btnStyle"
            btnArrowFlag={false}
        />
    </div>
);

export default CTAButton;
